module.exports = __webpack_public_path__ + "static/media/landing.22a04b79.png";